import ActivityFeedViewModel from '@/Components/ActivityFeed/ActivityFeedViewModel';
import layout from './ActivityFeed.html?raw';
import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import ActivityFeedOptionsWindow from '@/Components/ActivityFeed/Options/ActivityFeedOptionsWindow';
import ActivityFeedOptionsWindowViewModel from '@/Components/ActivityFeed/Options/ActivityFeedOptionsWindowViewModel';

export default class ActivityFeed extends Control {
    private jQueryControl: JQuery;

    private optionsWindow: ActivityFeedOptionsWindow;

    constructor(private viewModel: ActivityFeedViewModel, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));

        this.defineSubscription(this.viewModel.moreDataLoaded, loaded => {
             if (!loaded)
                 return;

             let scrollElement = this.jQueryControl.find('.load-more-link')[0] ||
                 this.jQueryControl.find('.time-unit-group:last-of-type .activity-feed-item:last-of-type')[0];
             if (scrollElement) {
                 scrollElement.scrollIntoView({ block: 'end' });
             }
        });
        this.optionsWindow = this.createOptionsWindow(viewModel.optionsWindow);
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.viewModel.refresh(false);

        this.applyTemplate(layout, this.jQueryControl, () => {
            this.optionsWindow.getTuple();
            this.widget(null);
        });

        return this.jQueryControl;
    }

    private createOptionsWindow(viewModel: ActivityFeedOptionsWindowViewModel): ActivityFeedOptionsWindow {
        return new ActivityFeedOptionsWindow(viewModel);
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'activity-feed',
            locator: this.viewModel.locator,
            technicalName: this.viewModel.technicalName,
            controlIdent: this.identifier,
            tooltip: this.viewModel.tooltip,
            visible: this.viewModel.isVisible,
        });

        const $content = this.jQueryControl.find('.activity-feed-content');
        if ($content.length) {
            this.applyBindings($content, {
                loader: this.viewModel.isBusy,
            });
        }

        const $optionsButton = this.jQueryControl.find('.options-button');
        if ($optionsButton.length) {
            this.applyBindings($optionsButton, {
                click: () => {
                    this.viewModel.openOptions();
                }
            });
        }
    }
}

ComponentManager.setControl('ActivityFeed', ActivityFeed, 'RADPresentation.HTMLClient.DefaultViewExtensions');